let originUrl = window.location.origin;
let baseURL = originUrl.includes('localhost') ? process.env.REACT_APP_API_URL : `${originUrl}/api`;

export const userModuleURL = {
  login: baseURL + '/auth-services/public/login',
  register: baseURL + '/auth-services/public/register',
  resetPassword: baseURL + '/profile-master-services/public/forget-password',
  changePasswordRequest: baseURL + '/profile-master-services/public/change-password-request',
  sendAuthCodeToServer: baseURL + '/profile-master-services/public/google-signup',
  logout: baseURL + '/profile-master-services/private/logout',
  fetchUserDetails: baseURL + '/profile-master-services/private/fetch-user-details',
  updateUserDetails: baseURL + '/profile-master-services/private/update-user-details',
  updatePasswordRequest: baseURL + '/profile-master-services/private/update-password',
  verifyUser: baseURL + '/profile-master-services/public/verify-user',
  fetchNotification: baseURL + '/notification-services/fetch-notification',
  updateNotification: baseURL + '/notification-services/update-read-receipts',
  resendVerificationMail: baseURL + '/profile-master-services/private/resend-verify-email',
  getAllPlan: baseURL + '/payment-services/get-all-plans?timezone=',
  appSumoRegisteration: baseURL + '/profile-master-services/public/create-appsumo-account',
  fetchUsersBrand: baseURL + '/profile-master-services/private/fetch-users-brand',
  intialLoad: baseURL + '/auth-services/private/initial-load',
  createNewBrand: baseURL + '/profile-master-services/private/create-new-brand',
  updateBrand: baseURL + '/profile-master-services/private/update-brand-details',
  leaveBrand: baseURL + '/profile-master-services/private/leave-from-brand',
  leaveOrganization: baseURL + '/profile-master-services/private/leave-from-org',
  deleteBrand: baseURL + '/profile-master-services/private/delete-brand',
  getAllRoles: baseURL + '/profile-master-services/private/fetch-all-roles',
  disableUser: baseURL + '/profile-master-services/private/disable-user',
  enableBrandUser: baseURL + '/profile-master-services/private/enable-brand-user',
  disableBrandUser: baseURL + '/profile-master-services/private/disable-brand-user',
  enableUser: baseURL + '/profile-master-services/private/enable-user',
  disableBrand: baseURL + '/profile-master-services/private/disable-brand',
  enableBrand: baseURL + '/profile-master-services/private/enable-brand',
  getAllUsers: baseURL + '/profile-master-services/private/fetch-brand-users',
  removeUserFromOrg: baseURL + '/profile-master-services/private/remove-user-from-org',
  removeFromBrand: baseURL + '/profile-master-services/private/remove-user-from-brand',
  createNewUser: baseURL + '/auth-services/private/send-invite-create-account',
  updateUser: baseURL + '/profile-master-services/private/update-user-role',
  getOrgUsers: baseURL + '/profile-master-services/private/fetch-org-users',
  updateOrg: baseURL + '/profile-master-services/private/update-org-details',
  deleteOrg: baseURL + '/profile-master-services/private/delete-org',
  createOrg: baseURL + '/profile-master-services/private/create-org',
  createBrand: baseURL + '/profile-master-services/private/create-brand',
  newUserInit: baseURL + '/auth-services/private/new-user-init',
  createUserFromToken: baseURL + '/auth-services/public/create-user-invite-account',
  getAllPendingInvites: baseURL + '/profile-master-services/private/get-all-pending-invites',
  deleteInvite: baseURL + '/profile-master-services/private/delete-invite',
  resendInvite: baseURL + '/profile-master-services/private/resend-invite',
  fetchBrandInfo: baseURL + '/profile-master-services/private/fetch-brand-info',
  fetchOrgInfo: baseURL + '/profile-master-services/private/fetch-org-info',
  fetchOrgAdmins: baseURL + '/profile-master-services/private/fetch-org-admins',
  deleteMe: baseURL + '/profile-master-services/private/delete-me',
  getDomainDetails: baseURL + '/profile-master-services/public/get-domain-details',
  getNotificationSetting: baseURL + '/notification-services/get-notification-settings',
  saveNotificationSetting: baseURL + '/notification-services/save-notification-settings',
  getChatSetupStatus: baseURL + '/chat-services/setup-status',
  chatWidgetSettings: baseURL + '/chat-services/widget-settings',
  faqSettings: baseURL + '/faq-services/settings',
  faqItems: baseURL + '/faq-services/items',
  kbSettings: baseURL + '/kb-services/settings',
  kbCollections: baseURL + '/kb-services/collections',
  kbArticles: baseURL + '/kb-services/articles',
  publicKB: baseURL + '/kb-public/brand',
  aiChatSettings: baseURL + '/ai-chat-services/settings',
  aiChatSources: baseURL + '/ai-chat-services/sources',
  aiChatDocumentSource: baseURL + '/ai-chat-services/sources/document',
  aiChatSourceDelete: baseURL + '/ai-chat-services/sources/delete',
  aiChatTestAnswer: baseURL + '/ai-chat-services/test-answer',
  liveChatSettings: baseURL + '/live-chat-services/settings',
  liveChatConversations: baseURL + '/live-chat-services/conversations',
  liveChatUnreadCount: baseURL + '/live-chat-services/unread-count',
  liveChatAnalyticsDashboard: baseURL + '/live-chat-services/analytics-dashboard',
  liveChatNotificationSubscriptions: baseURL + '/live-chat-services/notification-subscriptions',
  tickets: baseURL + '/ticket-services/tickets',
  createTicketFromConversation: baseURL + '/ticket-services/conversations/create-ticket',
  ticketMailbox: baseURL + '/ticket-services/mailbox',
  ticketMailProvider: baseURL + '/ticket-services/mail-provider',
  deleteticketMailProvider: baseURL + '/ticket-services/delete-mail-provider',
  ticketForwardingVerification: baseURL + '/ticket-services/mail-provider/forwarding-verification',
  whatsappConversations: baseURL + '/whatsapp-services/conversations',
  whatsappConversationMessages: (conversationId) =>
    baseURL + `/whatsapp-services/conversations/${conversationId}/messages`,
  whatsappConversationRead: (conversationId) =>
    baseURL + `/whatsapp-services/conversations/${conversationId}/read`,
  whatsappConversationClose: (conversationId) => baseURL + `/whatsapp-services/conversations/${conversationId}/close`,
  whatsappConnect: baseURL + '/whatsapp-services/connect',
  whatsappReauthenticate: baseURL + '/whatsapp-services/reauthenticate',
  whatsappRegister: (id) => baseURL + `/whatsapp-services/accounts/${id}/register`,
  whatsappAccountRefresh: (id) => baseURL + `/whatsapp-services/accounts/${id}/refresh`,
  facebookAuth: baseURL + '/facebook-services/auth',
  facebookAuthPages: baseURL + '/facebook-services/auth/pages',
  facebookIntegratePages: baseURL + '/facebook-services/integrate-pages',
  facebookReauthenticate: baseURL + '/facebook-services/reauthenticate',
  facebookAccountRefresh: (id) => baseURL + `/facebook-services/accounts/${id}/refresh`,
  facebookConversations: baseURL + '/facebook-services/conversations',
  facebookConversationMessages: (conversationId) =>
    baseURL + `/facebook-services/conversations/${conversationId}/messages`,
  facebookMessages: baseURL + '/facebook-services/messages',
  instagramAuth: baseURL + '/instagram-services/auth',
  instagramAuthAccounts: baseURL + '/instagram-services/auth/accounts',
  instagramIntegrateAccounts: baseURL + '/instagram-services/integrate-accounts',
  instagramReauthenticate: baseURL + '/instagram-services/reauthenticate',
  instagramAccountRefresh: (id) => baseURL + `/instagram-services/accounts/${id}/refresh`,
  instagramConversations: baseURL + '/instagram-services/conversations',
  instagramConversationMessages: (conversationId) =>
    baseURL + `/instagram-services/conversations/${conversationId}/messages`,
  instagramMessages: baseURL + '/instagram-services/messages',
  connectedProfiles: baseURL + '/integration-services/connected-profiles',
  connectedProfilesInactive: baseURL + '/integration-services/connected-profiles/inactive',
  connectedProfileDelete: (serviceName, profileId) =>
    baseURL + `/integration-services/connected-profiles/${serviceName}/${profileId}`,
  connectedProfileEnable: (serviceName, profileId) =>
    baseURL + `/integration-services/connected-profiles/${serviceName}/${profileId}/enable`,
  connectedProfileAutomation: (serviceName, profileId) =>
    baseURL + `/integration-services/connected-profile-automation/${serviceName}/${profileId}`,
  socialSupportTicket: baseURL + '/integration-services/social-support-ticket',
  uploadAiContent: baseURL + '/integration-services/upload-ai-content',
  getOnboardingInfoFromWebsite: baseURL + '/integration-services/get-onboarding-info-from-website',
  saveOnBoardingInfo: baseURL + '/profile-master-services/private/save-org-info',
  getStartedChecklist: baseURL + '/profile-master-services/private/get-started-checklist',
  updateGetStartedChecklist: baseURL + '/profile-master-services/private/get-started-checklist',
  skipPaymentAddTrailOnboarding: baseURL + '/payment-services/add-start-trail',
  getCurrentPlan: baseURL + '/payment-services/get-current-plan-details',
  getCurrentSubscription: baseURL + '/payment-services/get-current-plan-details',
  getStripeSubscriptionDetails: baseURL + '/payment-services/subscription-details',
  getAddonUpgradePrice: baseURL + '/payment-services/add-on-upgrade',
  getAddonDowngradePrice: baseURL + '/payment-services/add-on-downgrade',
  changePlanPrice: baseURL + '/payment-services/change-plan',
  couponUpdate: baseURL + '/profile-master-services/private/upgrade-to-lifetime-account',
  getLanguageJson: baseURL + '/profile-master-services/public/language',
  getBrandingDetails: baseURL + '/profile-master-services/private/get-branding-details',
  deleteCustomEmailDetails: baseURL + '/profile-master-services/private/delete-custom-email',
  saveDomainDetails: baseURL + '/profile-master-services/private/save-domain-details',
  updateBrandingDetails: baseURL + '/profile-master-services/private/update-branding',
  addCName: baseURL + '/profile-master-services/private/add-cname',
  verifyCName: baseURL + '/profile-master-services/private/verify-cname',
  deleteCName: baseURL + '/profile-master-services/private/delete-cname',
};

export const postsModuleURL = {
  scheduledEventInfo: baseURL + '/integration-services/scheduled-event-info?schedule_post_id=',
  orgScheduledEventInfo: baseURL + '/integration-services/org-scheduled-event-info?schedule_post_id=',
};

export const integrateModuleURL = {
  handleContactUs: baseURL + '/profile-master-services/public/contact-us',
};

export const paymentModuleUrl = {
  createPayment: baseURL + '/payment-services/change-plan-payment',
  checkPayment: baseURL + '/payment-services/check-payment?payment_intent=',
  addonPayment: baseURL + '/payment-services/add-on-upgrade-payment',
  getForNextBill: baseURL + '/payment-services/pay-for-next-bill',
  payForNextBill: baseURL + '/payment-services/pay-for-next-bill-payment',
  downGradePayment: baseURL + '/payment-services/add-on-downgrade-payment',
  getLifetimePlan: baseURL + '/payment-services/lifetime-plan',
  getDefaultPlans: baseURL + '/payment-services/default-plans',
  previewLifetimePlan: baseURL + '/payment-services/lifetime-plan-preview',
  lifetimePayment: baseURL + '/payment-services/lifetime-plan-payment',
  previewCustomLifetimePlan: baseURL + '/payment-services/custom-lifetime-plan-preview',
  customLifetimePayment: baseURL + '/payment-services/custom-lifetime-plan-payment',
  customLifetimeRequest: baseURL + '/payment-services/custom-lifetime-plan-request',
  customLifetimeRequests: baseURL + '/payment-services/custom-lifetime-plan-requests',
};

export const imageModeuleUrl = {
  uploadMedia: baseURL + '/image-server/upload-media',
  fetchPrivateMediaMetadata: baseURL + '/image-server/fetch-private-media-metadata',
};

export const demoModuleUrl = {
  getDemoJson: baseURL + '/demo-service/private/get-demo-json',
};

export const errorModuleUrl = {
  logError: baseURL + '/profile-master-services/public/ui-error-log',
};
